<template>
  <StartGame v-if="!gameStarted" />
  <div class="container">
    <StartPage />
    <Output />
    <Input />
    <Keyboard></Keyboard>
  </div>
</template>

<script>

import StartGame from '@/components/Start'
import Input from '@/components/Input'
import Output from '@/components/Output'
import Keyboard from '@/components/Keyboard'

export default {
  name: 'App',
  components: {
    StartGame,
    Input,
    Output,
    Keyboard,
  },
  data() {
    return {
      gameStarted: false,
    }
  },
  methods: {
    handleGameStarted() {
      this.gameStarted = true
    },
    handleGameReset() {
      this.gameStarted = false
    },
  },
  mounted() {
    this.$bus.on('app:game-started', this.handleGameStarted)
    this.$bus.on('app:reset-game', this.handleGameReset)
  },
}
</script>

<style lang="css" scoped>

</style>

